function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EFC649",
  d: "M187.5,334.091247 L191.064212,327.754869 L191.935788,328.245131 L187.435788,336.245131 L187,337.019864 L186.564212,336.245131 L182.064212,328.245131 L182.935788,327.754869 L186.5,334.091247 L186.5,333.5 L187.5,333.5 L187.5,334.091247 Z M187.5,331.5 L186.5,331.5 L186.5,329.5 L187.5,329.5 L187.5,331.5 Z M187.5,327.5 L186.5,327.5 L186.5,325.5 L187.5,325.5 L187.5,327.5 Z M187.5,323.5 L186.5,323.5 L186.5,321.5 L187.5,321.5 L187.5,323.5 Z M187.5,319.5 L186.5,319.5 L186.5,317.5 L187.5,317.5 L187.5,319.5 Z M187.5,315.5 L186.5,315.5 L186.5,313.5 L187.5,313.5 L187.5,315.5 Z M187.5,311.5 L186.5,311.5 L186.5,309.5 L187.5,309.5 L187.5,311.5 Z M187.5,307.5 L186.5,307.5 L186.5,305.5 L187.5,305.5 L187.5,307.5 Z M187.5,303.5 L186.5,303.5 L186.5,301.5 L187.5,301.5 L187.5,303.5 Z M187.5,299.5 L186.5,299.5 L186.5,297.5 L187.5,297.5 L187.5,299.5 Z",
  transform: "translate(-182 -297)"
});

var SvgDiagramArrow = function SvgDiagramArrow(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 40,
    viewBox: "0 0 10 40"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/diagram-arrow.ebc78296.svg";
export { SvgDiagramArrow as ReactComponent };